import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiFormHelperText: { styleOverrides: ComponentsOverrides<Theme>['MuiFormHelperText'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            marginTop: 2,
            marginLeft: theme.spacing(2),
        }),
    },
};
